function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  id: "community-icon",
  transform: "translate(3.000000, 3.000000)",
  stroke: "#FF0026",
  strokeWidth: 5
}, React.createElement("path", {
  d: "M25.5,12.875 C25.2813981,9.6130773 26.3947823,6.40191805 28.58569,3.97542885 C30.7765977,1.54893965 33.8577669,0.114518273 37.125,0 C40.4054556,0.0946184597 43.5060897,1.52040718 45.7132111,3.94918392 C47.9203325,6.37796066 49.0437933,9.6004816 48.825,12.875 C48.825,21 45.825,29.4 37.125,29.4 C28.425,29.4 25.5,20.975 25.5,12.875 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M28.5,27 C25.520785,28.7117209 22.3807267,30.1268405 19.125,31.225 C17.1555303,31.8738448 15.5786548,33.3682094 14.825,35.3",
  id: "Shape"
}), React.createElement("path", {
  d: "M14.85,35.3 C14.0027868,40.1566883 13.9100289,45.1150225 14.575,50",
  id: "Shape"
}), React.createElement("path", {
  d: "M45.7,27 C48.679215,28.7117209 51.8192733,30.1268405 55.075,31.225 C57.0444697,31.8738448 58.6213452,33.3682094 59.375,35.3",
  id: "Shape"
}), React.createElement("path", {
  d: "M59.375,35.3 C60.2139063,40.1579764 60.2982316,45.116307 59.625,50",
  id: "Shape"
}), React.createElement("path", {
  d: "M6.7,17.65 C6.57694221,15.87645 7.17733209,14.1286578 8.36428306,12.8051133 C9.55123404,11.4815687 11.2235683,10.6950932 13,10.625 C14.8028362,10.6550341 16.51423,11.4241263 17.7336897,12.7522974 C18.9531493,14.0804685 19.5736553,15.8511588 19.45,17.65 C19.45,22.075 17.825,26.675 13.075,26.675 C8.325,26.675 6.7,22.075 6.7,17.65 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M8.375,25.35 C6.78621871,26.2757574 5.11178767,27.0459956 3.375,27.65 C2.29921513,28.0043753 1.43758878,28.8201704 1.025,29.875",
  id: "Shape"
}), React.createElement("path", {
  d: "M0.925,30 C0.377667389,31.6144452 0.325431311,33.3556478 0.775,35",
  id: "Shape"
}), React.createElement("path", {
  d: "M67.7,17.65 C67.9138516,15.2376392 66.7477037,12.9111995 64.6869392,11.6390097 C62.6261747,10.3668198 60.0238253,10.3668198 57.9630608,11.6390097 C55.9022963,12.9111995 54.7361484,15.2376392 54.95,17.65 C54.95,22.075 56.575,26.675 61.325,26.675 C66.075,26.675 67.7,22.075 67.7,17.65 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M66.05,25.35 C67.6387813,26.2757574 69.3132123,27.0459956 71.05,27.65 C72.1257849,28.0043753 72.9874112,28.8201704 73.4,29.875",
  id: "Shape"
}), React.createElement("path", {
  d: "M73.5,30 C74.0473326,31.6144452 74.0995687,33.3556478 73.65,35",
  id: "Shape"
})));

var SvgCommunityIcon = function SvgCommunityIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "80px",
    height: "56px",
    viewBox: "0 0 80 56",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCommunityIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/community-icon.cc5402d9.svg";
export { ForwardRef as ReactComponent };